import { render, staticRenderFns } from "./KnowledgeBaseCategory.vue?vue&type=template&id=78dcd43b"
import script from "./KnowledgeBaseCategory.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseCategory.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseCategory.vue?vue&type=style&index=0&id=78dcd43b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports